import { Component, EventEmitter, Input, OnInit, Output, forwardRef } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from '@angular/forms';

@Component({
  selector: 'fx-input-number',
  templateUrl: './input-number.component.html',
  styleUrls: ['./input-number.component.sass'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputNumberComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => InputNumberComponent),
      multi: true
    }
  ]
})
export class InputNumberComponent implements OnInit, ControlValueAccessor, Validator {
  @Input() readonly: boolean = false;
  @Input() max: number | undefined;
  @Input() min: number | undefined;
  @Input() required: boolean = false;
  @Input() 
  set precision(value: number) {
    this._precision = value;
    if (value >= 0) {
      this.setMask();
    }
  };
  _precision: number = 0;

  @Output() 
  onChange: EventEmitter<number> = new EventEmitter();

  stringValue: string;
  value: number;
  disabled: boolean = false;
  mask: string = "0*";

  onChangeFn: (data: any) => void;
  onTouchedFn: () => void;
  constructor() { }

  validate(control: AbstractControl): ValidationErrors {
    let validateError = null;
    if (this.required && (this.value === undefined || this.value === null)) {
      validateError = validateError ?? {}
      validateError.required = true;
    }
    if (this.min !== null || this.min !== undefined) {
      if (this.value < this.min) {
        validateError = validateError ?? {};
        validateError.min = true;
      }
    }
    if (this.max !== null || this.max !== undefined) {
      if (this.value > this.max) {
        validateError = validateError ?? {};
        validateError.max = true;
      }
    }
    return validateError;
  }
  writeValue(value: number): void {
    this.value = value;
    if (this.value === undefined || this.value === null) {
      this.stringValue = '';
    }
    else {
      this.stringValue = String(this.value);
    }
  }

  registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedFn = fn
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  ngOnInit(): void {
  }

  private setMask() {
    if (this._precision == 0) {
      this.mask = "0*"
    }
    else {
      this.mask = `0*.${'0'.repeat(this._precision)}`;
    }
  }

  private getNumberValue(stringValue: string) {
    let value: number;
    if (Number.isNaN(+stringValue)) {
      stringValue = stringValue.replace(/\D/g, '');
      value = +stringValue;
    } else {
      value = +stringValue;
    }
    return value;
  }

  onInput(event: InputEvent) {
    const input = event.currentTarget as HTMLInputElement;
    this.value = this.getNumberValue(input.value);
    this.onChangeFn(this.value);
    this.onTouchedFn();
    this.onChange.emit(this.value);
  }

}
